// Store
import {setLoading} from './generalActions';
import {AppDispatch} from '../../store';
import shipmentServices from '../../../api/shipmentServices';

// Types
import {CancelGuideType, ReCreateGuideType} from "../../../types/shipmentTypes";

// Components and Subcomponents
import {ERROR_MODAL, SUCCESS_MODAL} from '../../../components/subComponents/responseModals';

// Store
import {getDetailByOrderNumber} from "./orderActions";


export const cancelGuide = (data: CancelGuideType, orderNumber: string) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  shipmentServices.cancelGuide(data)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getDetailByOrderNumber(orderNumber));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}

export const reCreateGuide = (data: ReCreateGuideType, orderNumber: string) => async (dispatch: AppDispatch) => {
  dispatch(setLoading(true));
  shipmentServices.reCreateGuide(data)
    .then((response) => {
      SUCCESS_MODAL(response.data.status);
      dispatch(getDetailByOrderNumber(orderNumber));
    })
    .catch(err => {
      ERROR_MODAL(err.data.error);
      dispatch(setLoading(false));
    })
}